<template>
  <audio
    ref="audioEl"
    :src="currentSrc"
    @timeupdate="onTime"
    @loadedmetadata="onMeta"
    @ended="onEnded"
  />
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'GlobalAudio',
  computed: {
    ...mapState('audio', ['playing', 'volume', 'currentId']),
    ...mapGetters('audio', ['current']),
    currentSrc() {
      return this.current?.src || null
    },
  },
  watch: {
    playing(v) {
      if (!this.$refs.audioEl) return
      if (v) {
        this.$refs.audioEl.play().catch(() => {})
      } else {
        this.$refs.audioEl.pause()
      }
    },
    current() {
      this.$nextTick(() => {
        if (this.playing && this.$refs.audioEl) {
          this.$refs.audioEl.play().catch(() => {})
        }
      })
    },
    volume(v) {
      if (this.$refs.audioEl) this.$refs.audioEl.volume = v
    },
  },
  methods: {
    onTime() {
      if (this.$refs.audioEl) {
        this.$store.commit('audio/setTime', this.$refs.audioEl.currentTime)
      }
    },
    onMeta() {
      if (this.$refs.audioEl) {
        this.$store.commit('audio/setDuration', this.$refs.audioEl.duration)
      }
    },
    onEnded() {
      this.$store.commit('audio/setPlaying', false)
    },
  },
}
</script>
